import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyA9loqiOiOwyWxvSCJU8Dtg7TzhvVWTYeg",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "coin-collector-381ff.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "coin-collector-381ff",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "coin-collector-381ff.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "364779348596",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:364779348596:web:fab8c2acae207d1ef9a721",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;

